module.exports = __webpack_public_path__ + "img/shortcode_digital_wireframe.f9da3ac5.png";